import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";
import { accountIdSchema } from "./accountSchema";
import { loadIdSchema } from "./loadSchema";
import { scaleIdSchema } from "./scaleSchema";

export const hiveIdPrefix = "hiv_";
export type HiveId = ID<typeof hiveIdPrefix>;
export const generateHiveId = makeIdGenerator(hiveIdPrefix);
export const hiveIdSchema = getIdSchema(hiveIdPrefix, "HiveId");

export const hiveSchema = z
  .object({
    id: hiveIdSchema,
    accountId: accountIdSchema,
    loadId: loadIdSchema,
    name: z.string(),
    retiredAt: z.coerce.date().nullable(),
    currentScaleId: scaleIdSchema.nullable(),
    createdAt: z.coerce.date(),
    firstReport: z.coerce.date().nullable(),
    lastReport: z.coerce.date().nullable(),
    location: z.object({ name: z.string(), since: z.coerce.date() }).optional(),
  })
  .meta({ id: "Hive" });

export type Hive = z.infer<typeof hiveSchema>;

// Request body for PUT /api/hives/:id (rename + retire)
export const putHiveSchema = z
  .object({
    name: z.string().min(1),
    retiredAt: z.coerce.date().nullable(),
    loadId: loadIdSchema.optional(),
  })
  .meta({ id: "HiveUpdate" });
export type PutHive = z.infer<typeof putHiveSchema>;

// Request body for PUT /api/hives/:id/load (reassign)
export const reassignHiveLoadSchema = z
  .object({
    loadId: loadIdSchema,
  })
  .meta({ id: "HiveLoadReassignment" });
export type ReassignHiveLoad = z.infer<typeof reassignHiveLoadSchema>;
